import { useLocale } from '../context/LocaleContext';
import type { AppLocale } from '../i18n';

export default function LocaleToggle({ className = '' }: { className?: string }) {
  const { locale, setLocale } = useLocale();

  const btn = (loc: AppLocale, label: string) => (
    <button
      type="button"
      onClick={() => setLocale(loc)}
      className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
        locale === loc
          ? 'bg-[#1AD5F4]/20 text-[#1AD5F4] border border-[#1AD5F4]/40'
          : 'text-gray-400 hover:text-white border border-transparent'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className={`inline-flex items-center gap-0.5 rounded-full bg-white/5 p-0.5 ${className}`}>
      {btn('tr', 'TR')}
      {btn('en', 'EN')}
    </div>
  );
}
